/* eslint-disable */
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { RadioGroup, Radio } from "@common/AggregationComponent";
import { handleHeightLabel } from "@util/common";
import { CombinedReducersType } from "@type/index";

const OutfitTabHeightFilter = (props: any) => {
  const { heights, selectedHeight, selectedGender, onChangeSelected } = props;

  const { t } = useTranslation();
  const searchResult = useSelector(
    (state: CombinedReducersType) => state.searchResult
  );

  const res = useMemo(() => {
    return (
      <div>
        <RadioGroup
          columnCount={{ sm: 2, md: 2, lg: 2 }}
          legend={t("text_height")}
        >
          {heights.map((height: any) => (
            <Radio
              checked={height.value === selectedHeight.value}
              id={`outfit-tab-new-filter-height-raido-${height.value}`}
              key={`outfit-tab-new-filter-${height.key}`}
              label={handleHeightLabel(height, t)}
              name="outfit-tab-new-filter-height-radio"
              onChange={() => {
                onChangeSelected(selectedGender, height, false);
              }}
              value={height.value}
            />
          ))}
        </RadioGroup>
      </div>
    );
  }, [searchResult.outFitResult.similarOutfits, heights]);

  return <>{res}</>;
};
export default OutfitTabHeightFilter;
